import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import trackAccess from './trackAccess';

/**
 * Wraps a route and fires a tracking event on mount.
 *
 * Props:
 *   moduleId    — unique module identifier
 *   moduleName  — human-readable module name
 *   projectName — the single project this access belongs to (optional)
 *
 * Usage in Routes.js:
 *   <TrackableRoute
 *     moduleId="Beacon4Performance"
 *     moduleName="Beacon4 Performance"
 *     projectName="VMO2 Dashboards"
 *   >
 *     <MyPage />
 *   </TrackableRoute>
 */
const TrackableRoute = ({ moduleId, moduleName, projects, children }) => {
	const user = useSelector(state => state.session.user);

	useEffect(() => {

		if (!user?.id || !moduleId) return;

		trackAccess(moduleId, moduleName, user.id, projects);
	}, []);

	return children;
};

export default TrackableRoute;